
import '../../../src/assets/js/modules/Core/scss/_footer.scss';

import {setupFooterDropdowns} from '../../../src/assets/js/modules/Core/scripts/utilities';

document.addEventListener('DOMContentLoaded', function() {
    setupFooterDropdowns();
})

function dataLayerSend(eCat, eLabel, eAct) {
    dataLayer.push({
        'event': 'myTrackEvent',
        'eventCategory': eCat,
        'eventLabel': eLabel,
        'eventAction': eAct
    });
}


function thankyoupage_animateButtonSuccess(element) {
    //Hide existing text and show tick
    element.querySelector('.tickConfirmation').classList.remove('hide');
    element.querySelector('.original-text').style.display = "none";
    element.querySelector('.tickConfirmation').classList.add('animated');
    element.querySelector('.tickConfirmation').classList.add('fadeInUp');
    element.querySelector('.tickConfirmation').classList.add('faster');

    //slide entire row out
    setTimeout(function() {
        //console.log(element.parentNode.parentNode);
        element.parentNode.parentNode.classList.add('animated');
        element.parentNode.parentNode.classList.add('fadeOut');
        element.parentNode.parentNode.classList.add('fastest');
        setTimeout(function() {
            element.parentNode.parentNode.classList.add('hideSlowly');
        },500);
        //After animation set display none
        setTimeout(function() {
            element.parentNode.parentNode.style.display ="none";
            
            //remove item from owl carousel by first gettings its index by counting back siblings
            var node = element.parentNode.parentNode.parentNode;
            var owl = node.parentNode.parentNode.parentNode;
            for (var itemIndex=0; (node=node.previousSibling); itemIndex++);

            //Get the owl carousel object && remove the index of this selected element, then
            //refresh the owl
            $(owl).trigger('remove.owl.carousel', [itemIndex]).trigger('refresh.owl.carousel');
            

        },1000);
    },1000)
}

function thankyoupage_animateButtonFail(element) {
    //Start by setting the button to red and show the error text and icon
     element.classList.add('failed');
     element.querySelector('.crossFailed').classList.remove('hide');
     element.querySelector('.original-text').style.display = "none";
     element.querySelector('.crossFailed').classList.add('animated');
     element.querySelector('.crossFailed').classList.add('fadeInUp');
     element.querySelector('.crossFailed').classList.add('faster');
     //After a delay, show a more detailed error message
     setTimeout(function() {
         spawnErrorMessage(element);
     },400);
     //After a delay, set the button text back to normal
     setTimeout(function() {
         element.classList.remove('sending', 'failed');
         element.classList.remove('failed');
         element.querySelector('.crossFailed').classList.add('hide');
         element.querySelector('.original-text').style.display = "block";
         element.querySelector('.original-text').innerText = "Request Free Information"
         document.querySelector('.mid-heading').focus()
         element.blur();
     },5000);
}

//Show an error message under the active row
function spawnErrorMessage(element) {
    var thisRow = element.parentNode.parentNode;
    thisRow.insertAdjacentHTML('beforeEnd',
    '<div class="errorMessage animated fadeInDown fast">' +
     '<img class="upperArrow" src="https://cdn.what-franchise.com/assets/images/projects/upperArrow.svg">' +
     '<span> There was a problem requesting your free information </span> The server timed out, please try requesting again. If you\'re still having issues, please contact What Franchise support team <a href="mailto:support@what-franchise.com">support@what-franchise.com</a></div>')
}


function toggleGDPR() {
    document.querySelector('.gdpr-full').classList.toggle('hideGDPR');
    
    var mask = document.querySelector('.mask');
    mask.classList.toggle('show');
}


$(document).ready(function(){
    var optionalElements = document.querySelectorAll('.optional-info-trigger');
    if (optionalElements.length > 0 ) {
        for (var x = 0; x < optionalElements.length; x++) {
            optionalElements[x].addEventListener('click', function(event) {

                event.stopPropagation();
                event.target.parentNode.querySelector('.optional-information').classList.toggle('hidden');
                event.target.parentNode.querySelector('.fa-chevron-down').classList.toggle('spin');
            })
        }
    }
});






// MOBILE SEARCH OPEN/CLOSE
var searchForm = document.getElementsByClassName('search_form')[0];
function showSearch() {
    if (searchForm.classList.contains('open')) {
        searchForm.classList.remove('open');
    } else {
        searchForm.classList.add('open');
    }
}


// SIDEBAR OPEN/CLOSE
var sidebar = document.getElementsByClassName('sidebar')[0];
var main = document.getElementsByClassName('main')[0];
var mask = document.getElementsByClassName('mask')[0];
var catfish = document.getElementsByClassName('shortlist-catfish')[0];

// NAVBAR SCROLL BEHAVIOUR
$(function () {
    var lastScrollTop = 0, delta = 5;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();

        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        if (st > lastScrollTop && st > 88) {
            // downscroll code
            $('.main-nav').addClass('fixed-header');
        } else {
            // upscroll code
            $('.main-nav').removeClass('fixed-header');
        }
        lastScrollTop = st;
    });
});

function toggleShortlistView() {
    document.getElementById('shortlist-checkboxes').classList.toggle('mobile-hide');
    document.getElementById('shortlist-toggle-arrow').classList.toggle('spun');
}

function showOptionalInfo(element, entryId) {
    var arrow = element.nextElementSibling;
    var accordion = arrow.nextElementSibling;
    accordion.classList.toggle('hidden');
    arrow.classList.toggle('spun');
    //If on a company page, expanding the optional info should also tick the box
    if (entryId) {
        handleChecked(entryId);
        //Enable checkbox of this company on the catfish
        var el = document.querySelector("#thisCompany");
        updateCheckbox(el, el.checked);
    }
}


function updateName(el) {
    $('.enquiry-name').each(function () {
        $(this).val(el.value);
    });
}
function updateEmail(el) {
    $('.enquiry-email').each(function () {
        $(this).val(el.value);
    });
}
function updateTelephone(el) {
    $('.enquiry-telephone').each(function () {
        $(this).val(el.value);
    });
}
function updateText(el) {
    $('.enquiry-text').each(function () {
        $(this).val(el.value);
    });
}







//Global scope var to store which button was pressed on the enquiry form
var clickedButton = '';


//Multi-Enquiry-Form
// window.onload = function() 
// {
//     // var enquiryForms = document.querySelectorAll('.multi-enquiry-form');
//     // for (x = 0; x < enquiryForms.length; x++)
//     // {
//     //     enquiryForms[x].addEventListener('submit', function(event) {handleMultiForm(event)});
//     // }

//     var mainEnquiryForms = document.querySelectorAll('.enquiry-form');
//     for (x = 0; x < mainEnquiryForms.length; x++)
//     {
//         mainEnquiryForms[x].addEventListener('submit', function(event) {handleMultiFormMain(event)});
//     }

//     //Fires just before the multi-form submit below, to store which button was clicked (was it multi or single?)
//     var submitButtons = document.querySelectorAll('input[type="submit"]');
//     for (x = 0; x < submitButtons.length; x++)
//     {
//         submitButtons[x].addEventListener('click', function(event) {
//             clickedButton = event.target.classList;
//         })
//     }
// }


//Gets called when the new multi-franchise form gets submitted
//Works out whether they enquired to all franchises, or just one, and then submits
//the enquiry via Ajax and hands off to the thank-you page
// function handleMultiForm(event)
// {
//     event.preventDefault();

//     //hide form output
//     event.target.parentNode.querySelector('.form-output').style.display = 'none';

//     //hide submit buttons
//     var buttons = event.target.querySelectorAll('input[type="submit"');
//     for (var x = 0; x < buttons.length; x++)
//     {
//         buttons[x].style.display='none';
//     }

//     //show loading spinner
//     event.target.querySelector('.directory-spinner').style.display = 'block';

//     //retrieve all the entry_ids of the franchises in the form
//     var companies = [];
//     var nodeList = event.target;
//     for (var x=0; x < nodeList.length; x++)
//     {
//         if (nodeList[x].name == 'company_info[]')
//         {
//             companies.push(nodeList[x].value);
//         }
//     }



//     //retrieve values from the form
//     var name = event.target.querySelector('input[name="name"]').value;
//     var email = event.target.querySelector('input[name="email"]').value;
//     var telephone = event.target.querySelector('input[name="telephone"]').value
//     var csrf = event.target.querySelector('input[name="csrf_token"]').value;
//     var device_width = event.target.querySelector('input[name="device_width"]').value
//     var location = event.target.querySelector('input[name="location"]').value;
//     var enquiry = event.target.querySelector('.enquiry-text').value
    
    
//     //If they didnt select the multi option, just splice off the 1st index
//     if (!clickedButton.contains('multi-button'))
//     {
//         companies = [companies[0]];
//     }

//     //Build data object & submit enquiry
//     var params = {
//         'name': name,
//         'email': email,
//         'telephone': telephone,
//         'enquiry': enquiry,
//         'company_info[]': companies,
//         'device_width': device_width,
//         'location': location,
//         'csrf_token': csrf,
//         'multi': clickedButton.contains('multi-button')
//     }
//     var loadThankYou = true;
//     ajaxRequest('/assets/php/enquiry-submit.php', 
//         params, 
//         function(response){multiEnquirySuccess(response,event, loadThankYou, params)}, 
//         function(response){multiEnquiryFail(response, event)});
// }

// function multiEnquirySuccess(response, event, loadThankYou, params)
// {
//     if (response != '"success"')
//     {
//         multiEnquiryFail(response, event);
//         return;
//     }

//     //Load the thank you page
//     if (loadThankYou)
//     {
//         //tell the thank-you page to not actually process anything - the enquiry has already been submitted
//         params.functionless = true;
//         post('/thank-you', params )
//     }

//     //Submit analytics success event
//     dataLayerSend({"event": "myTrackEvent",
//     "eventCategory": "Enquiry Success",
//     "EventAction": 'submit',
//     "EventLabel": 'Multi Enquiry Form'});



// }

// //Failed to send the enquiry, display a message to the user
// function multiEnquiryFail(response, event)
// {
//     //hide loading spinner
//     event.target.querySelector('.directory-spinner').style.display = 'none';

//     //Output response
//     event.target.parentNode.querySelector('.form-output').innerText = 'There was an error while submitting your enquiry, please try again.'
//     event.target.parentNode.querySelector('.form-output').style.display = 'block';

//     //Show enquiry buttons again
//     var buttons = event.target.querySelectorAll('input[type="submit"');
//     for (var x = 0; x < buttons.length; x++)
//     {
//         buttons[x].style.display='block';
//     }
// }
















function createUKPrompt() {
    //document.querySelector('.int-checker').classList.remove('d-none');
    document.querySelector('#uk-franchise').checked = false;
}
